import { createSlice } from "@reduxjs/toolkit";
import { APIStatus } from "../../constants";
import { getAllCollege, createCollege, UpdateCollage, deleteCollege } from "./college.service";
import { CollageReducer } from "../../modal/college";

const initialState: CollageReducer = {
	createCollegeComplete: null,
	updateCollageComplete: null,
	getAllCollegeComplete: null,
	colleges: [],
	totalCount: 0,
	dataLoading: false,
	deleteCollegeComplete: null,
};

const collegeslice = createSlice({
	name: "colleges",
	initialState,
	reducers: {
		clearCreateCollege(state) {
			state.createCollegeComplete = null;
		},

		clearUpdateCollage(state) {
			state.updateCollageComplete = null;
		},

		cleargetAllCollege(state) {
			state.getAllCollegeComplete = null;
		},
		enableLoading(state) {
			state.dataLoading = true;
		},
		clearDeleteCollege(state) {
			state.deleteCollegeComplete = null;
		},
	},
	extraReducers(builder) {
		builder.addCase(UpdateCollage.fulfilled, (state, action) => {
			state.updateCollageComplete = APIStatus.FULFILLED;
		});
		builder.addCase(UpdateCollage.rejected, (state) => {
			state.updateCollageComplete = APIStatus.REJECTED;
		});

		builder.addCase(createCollege.fulfilled, (state, action) => {
			state.createCollegeComplete = APIStatus.FULFILLED;
		});
		builder.addCase(createCollege.rejected, (state) => {
			state.createCollegeComplete = APIStatus.REJECTED;
		});
		builder.addCase(deleteCollege.fulfilled, (state) => {
			state.deleteCollegeComplete = APIStatus.FULFILLED;
		});
		builder.addCase(deleteCollege.rejected, (state) => {
			state.deleteCollegeComplete = APIStatus.REJECTED;
		});

		builder.addCase(getAllCollege.fulfilled, (state, action) => {
			state.getAllCollegeComplete = APIStatus.FULFILLED;
			state.colleges = action.payload?.data?.data || [];
			state.totalCount = action?.payload?.data?.count || 0;
			state.dataLoading = false;
		});
		builder.addCase(getAllCollege.rejected, (state) => {
			state.getAllCollegeComplete = APIStatus.REJECTED;
			state.dataLoading = false;
		});
	},
});

export const { clearCreateCollege, clearUpdateCollage, cleargetAllCollege, enableLoading, clearDeleteCollege } =
	collegeslice.actions;

export default collegeslice.reducer;
